module.exports = __webpack_public_path__ + "36128539a769d6327eab713d3bbb7c7b.svg";